import store from '@/store';

function checkToken(from, to, next) {
  return store.dispatch('checkToken').then((res) => res.data);
};

export default async(from, to, next) => {
  if (!await checkToken('checkToken')) {
    return next('/auth/login');
  }

  return next();
};
